import React from 'react';

export default class LoadingSpinner extends React.Component {
    render() {
        return <div className={`spinner-container${this.props.alignRight ? "-right" : ""}`}>
            <svg className="spinner" width={`${this.props.height || 12}px`} height={`${this.props.height || 12}px`} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle className="circle" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
            </svg>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/LoadingSpinner.jsx